import React from "react";
import { Box } from "@chakra-ui/react";

export const VaporwaveCityBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex="0"
      pointerEvents="none"
    >
      {/* Dark gradient sky */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(180deg, #0a0015 0%, #1a0030 25%, #3d0050 45%, #ff0066 80%, #ff3366 100%)"
      />

      {/* Retro sun with horizontal lines */}
      <Box
        className="retro-sun"
        position="absolute"
        top="25%"
        left="50%"
        transform="translateX(-50%)"
        width="250px"
        height="250px"
        borderRadius="50%"
        background="linear-gradient(180deg, #ffff00 0%, #ff6600 30%, #ff0066 60%, #cc0066 100%)"
        clipPath="polygon(0 0, 100% 0, 100% 100%, 0 100%)"
        overflow="hidden"
      >
        {/* Sun horizontal lines */}
        <Box position="absolute" top="20%" left="0" width="100%" height="8px" backgroundColor="rgba(10,0,21,0.8)" />
        <Box position="absolute" top="35%" left="0" width="100%" height="10px" backgroundColor="rgba(10,0,21,0.8)" />
        <Box position="absolute" top="50%" left="0" width="100%" height="14px" backgroundColor="rgba(10,0,21,0.8)" />
        <Box position="absolute" top="65%" left="0" width="100%" height="18px" backgroundColor="rgba(10,0,21,0.8)" />
        <Box position="absolute" top="80%" left="0" width="100%" height="25px" backgroundColor="rgba(10,0,21,0.8)" />
      </Box>

      {/* City skyline SVG */}
      <svg
        className="city-svg"
        viewBox="0 0 1440 800"
        preserveAspectRatio="none"
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <defs>
          {/* Building gradients */}
          <linearGradient id="buildingGrad1" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#1a0030" stopOpacity="1" />
            <stop offset="100%" stopColor="#0a0015" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="buildingGrad2" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#2a0045" stopOpacity="1" />
            <stop offset="100%" stopColor="#0f001a" stopOpacity="1" />
          </linearGradient>

          {/* Neon glow filter */}
          <filter id="neonGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="3" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>

          {/* Grid gradient for perspective floor */}
          <linearGradient id="gridFloorGrad" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#ff0066" stopOpacity="0.6" />
            <stop offset="100%" stopColor="#ff0066" stopOpacity="0.1" />
          </linearGradient>
        </defs>

        {/* Back row buildings (darker, further) */}
        <g className="buildings-back">
          <rect x="50" y="350" width="80" height="200" fill="url(#buildingGrad1)" />
          <rect x="140" y="320" width="100" height="230" fill="url(#buildingGrad1)" />
          <rect x="260" y="380" width="70" height="170" fill="url(#buildingGrad1)" />
          <rect x="350" y="300" width="120" height="250" fill="url(#buildingGrad1)" />
          <rect x="490" y="360" width="90" height="190" fill="url(#buildingGrad1)" />
          <rect x="600" y="280" width="110" height="270" fill="url(#buildingGrad1)" />
          <rect x="730" y="340" width="80" height="210" fill="url(#buildingGrad1)" />
          <rect x="830" y="290" width="130" height="260" fill="url(#buildingGrad1)" />
          <rect x="980" y="350" width="85" height="200" fill="url(#buildingGrad1)" />
          <rect x="1080" y="310" width="100" height="240" fill="url(#buildingGrad1)" />
          <rect x="1200" y="370" width="75" height="180" fill="url(#buildingGrad1)" />
          <rect x="1290" y="330" width="110" height="220" fill="url(#buildingGrad1)" />
        </g>

        {/* Front row buildings (closer, more detail) */}
        <g className="buildings-front">
          <rect x="0" y="420" width="100" height="180" fill="url(#buildingGrad2)" />
          <rect x="110" y="380" width="130" height="220" fill="url(#buildingGrad2)" />
          <rect x="260" y="440" width="90" height="160" fill="url(#buildingGrad2)" />
          <rect x="370" y="400" width="110" height="200" fill="url(#buildingGrad2)" />
          <rect x="500" y="450" width="80" height="150" fill="url(#buildingGrad2)" />
          <rect x="600" y="390" width="140" height="210" fill="url(#buildingGrad2)" />
          <rect x="760" y="430" width="95" height="170" fill="url(#buildingGrad2)" />
          <rect x="875" y="380" width="120" height="220" fill="url(#buildingGrad2)" />
          <rect x="1015" y="440" width="85" height="160" fill="url(#buildingGrad2)" />
          <rect x="1120" y="400" width="100" height="200" fill="url(#buildingGrad2)" />
          <rect x="1240" y="450" width="90" height="150" fill="url(#buildingGrad2)" />
          <rect x="1350" y="410" width="100" height="190" fill="url(#buildingGrad2)" />
        </g>

        {/* Neon window lights on buildings */}
        <g className="neon-windows" filter="url(#neonGlow)">
          {/* Cyan windows */}
          <rect x="125" y="400" width="8" height="12" fill="#00ffff" className="window-blink-1" />
          <rect x="145" y="420" width="8" height="12" fill="#00ffff" className="window-blink-2" />
          <rect x="165" y="390" width="8" height="12" fill="#00ffff" className="window-blink-3" />
          <rect x="385" y="430" width="8" height="12" fill="#00ffff" className="window-blink-1" />
          <rect x="405" y="450" width="8" height="12" fill="#00ffff" className="window-blink-2" />
          <rect x="625" y="420" width="8" height="12" fill="#00ffff" className="window-blink-3" />
          <rect x="655" y="440" width="8" height="12" fill="#00ffff" className="window-blink-1" />
          <rect x="900" y="410" width="8" height="12" fill="#00ffff" className="window-blink-2" />
          <rect x="935" y="430" width="8" height="12" fill="#00ffff" className="window-blink-3" />
          <rect x="1145" y="420" width="8" height="12" fill="#00ffff" className="window-blink-1" />

          {/* Pink/magenta windows */}
          <rect x="135" y="440" width="8" height="12" fill="#ff00ff" className="window-blink-2" />
          <rect x="155" y="410" width="8" height="12" fill="#ff00ff" className="window-blink-3" />
          <rect x="395" y="460" width="8" height="12" fill="#ff00ff" className="window-blink-1" />
          <rect x="640" y="450" width="8" height="12" fill="#ff00ff" className="window-blink-2" />
          <rect x="680" y="420" width="8" height="12" fill="#ff00ff" className="window-blink-3" />
          <rect x="915" y="450" width="8" height="12" fill="#ff00ff" className="window-blink-1" />
          <rect x="1160" y="440" width="8" height="12" fill="#ff00ff" className="window-blink-2" />
        </g>

        {/* Horizon line */}
        <line x1="0" y1="550" x2="1440" y2="550" stroke="#ff0066" strokeWidth="2" filter="url(#neonGlow)" />
      </svg>

      {/* Darkening overlay for grid floor area */}
      <Box
        position="absolute"
        bottom="0"
        left="0"
        width="100%"
        height="30%"
        background="linear-gradient(180deg, transparent 0%, rgba(10,0,21,0.85) 100%)"
        pointerEvents="none"
      />

      {/* Perspective grid floor */}
      <Box
        className="grid-floor"
        position="absolute"
        bottom="0"
        left="-50%"
        width="200%"
        height="35%"
        style={{
          background: `
            repeating-linear-gradient(
              90deg,
              transparent,
              transparent 48px,
              rgba(255,0,102,0.4) 48px,
              rgba(255,0,102,0.4) 50px
            )
          `,
          transformOrigin: "center top",
          transform: "perspective(500px) rotateX(60deg)",
        }}
      />

      {/* Floating stars */}
      <Box className="vaporwave-stars" position="absolute" width="100%" height="50%" top="0" left="0" />

      {/* Scanline overlay effect */}
      <Box
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        opacity="0.03"
        backgroundImage="repeating-linear-gradient(
          0deg,
          transparent,
          transparent 2px,
          rgba(0,0,0,0.5) 2px,
          rgba(0,0,0,0.5) 4px
        )"
        pointerEvents="none"
      />
    </Box>
  );
};

export default VaporwaveCityBackground;
